import React from 'react'
import { Slider } from '../components'
import useScrollTop from '../hooks/useScrollTop';
import free_project_image from '../assets/img/free_project_image1.jpg';
import useDocTitle from '../hooks/useDocTitle';

const FreeProjectPage = () => {
    useScrollTop();
    useDocTitle("Free projects")

    return (
        <div className="bg-gray-50">
            <Slider image={free_project_image}/>

            <section className="my-5 py-10 px-2 sm:px-4 md:px-8 lg:px-12 xl:px-14">
                <div className="py-32">
                    <h2 className="text-2xl text-center">EMPTY</h2>
                </div>
            </section>
            
        </div>
    )
}

export default FreeProjectPage